import FirebaseService from './FirebaseService';
import FirestoreService from './FirestoreService';
import { Store } from 'vuex';
import { StoreState } from '../store/states';
import {
  VUEX_MUTATION_ADD_FAQS,
  VUEX_MUTATION_SET_CURRENT_FAQ,
} from '../store/mutations';

export default class FAQService {
  private static instance: FAQService;
  private store: Store<StoreState>;

  static getInstance(store: Store<StoreState>) {
    if (!FAQService.instance) {
      FAQService.instance = new FAQService(store);
    }
    return FAQService.instance;
  }

  private constructor(store: Store<StoreState>) {
    this.store = store;
    this.store.commit(
      VUEX_MUTATION_SET_CURRENT_FAQ,
      FirestoreService.getInstance().getFAQ()
    );
  }
}
